<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
      <div class="col-md-12">
        <yt-input
          [Type]="'text'"
          formControlName="Naziv"
          [MaxLength]="100"
          [Label]="'RADNOMESTO.SINGULAR'"
          [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}">
        </yt-input>
        <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
          <span *ngFor="let validation of errorMessages.Naziv">
            <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <yt-input [Type]="'text'" formControlName="Sifra" [Label]="'RADNOMESTO.SIFRA.SINGULAR'">
        </yt-input>      
      </div>
    </div>
     <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist 
            [ModelName]="'radnomesto'" 
            [GetName]="'getRoot'" 
            [ModelProperty]="'Naziv'" 
            [OrderBy]="'Naziv'"
            [AllowAddNew]='false' 
            formControlName="TataID" 
            [Label]="'RADNOMESTO.TATA.SINGULAR'" 
            [Type]="'treeview'">
        </yt-dropdown-picklist>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist 
            [ModelName]="'sprema'" 
            [GetName]="'get'" 
            [ModelProperty]="'Naziv'" 
            [OrderBy]="'Naziv'"
            [AllowAddNew]='true' 
            formControlName="MinSpremaID" 
            [Label]="'RADNOMESTO.SPREMA.SINGULAR'">
        </yt-dropdown-picklist>
      </div>
    </div> 
  </form>